import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';

/* Crew portal read/write layer (contractor role; admins pass for support). */

export default function useCrew() {
    const authenticatedApi = useAuthenticatedApi();

    const getAssignments = async () => {
        const response = await authenticatedApi.get('/crew/assignments');
        return response.data;
    };

    const respondToAssignment = async (
        assignmentId: number,
        action: 'confirm' | 'decline',
    ) => {
        const response = await authenticatedApi.post(
            `/crew/assignments/${assignmentId}/${action}`,
        );
        return response.data;
    };

    const getProfile = async () => {
        const response = await authenticatedApi.get('/crew/profile');
        return response.data;
    };

    const updateProfile = async (fields: Record<string, any>) => {
        const response = await authenticatedApi.put('/crew/profile', fields);
        return response.data;
    };

    const getCalendarFeed = async () => {
        const response = await authenticatedApi.get('/crew/calendar-feed');
        return response.data;
    };

    return {
        getAssignments,
        respondToAssignment,
        getProfile,
        updateProfile,
        getCalendarFeed,
    };
}
